import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import store from "@/store";

export function initAppInsights() {
  const instrumentationKey = process.env.VUE_APP_AZ_INSTRUMENTATION_KEY;
  if (!instrumentationKey) {
    console.warn(
      "\n⚠️ WARNING: Application Insights instrumentation key is not set.\n"
    );
    return;
  }

  if (window.appInsights) {
    return window.appInsights;
  }

  const appInsights = new ApplicationInsights({
    config: {
      instrumentationKey: process.env.VUE_APP_AZ_INSTRUMENTATION_KEY,
      disableFetchTracking: true,
      disableAjaxTracking: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      disableCookiesUsage: true
    }
  });

  appInsights.loadAppInsights();

  window.appInsights = appInsights;
}

export function trackEvent(name, event) {
  try {
    const isProduction = process.env.NODE_ENV === "production";
    const currentUser = store.getters["auth/currentUser"];
    const data = {
      name,
      properties: {
        ...event,
        location: window.location,
        currentUser
      }
    };
    if (isProduction && window.appInsights) {
      window.appInsights.trackEvent(data);
    } else {
      console.log("Track event:", data);
    }
  } catch (e) {
    console.error("Failed to track event", e);
  }
}
